// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"429":"c93b6993","551":"97b78eec","640":"2180dc23"}[chunkId] + ".chunk.js";
};